import { sineInOut } from 'svelte/easing'

export default function (node, params) {
    const { delay = 0, duration = 200, easing = sineInOut } = params

    return {
        delay,
        duration,
        easing,
        css: (t) =>
            `transform: scale(${t}) ; transform-origin: 50% 50% ; opacity: ${t};position: absolute`,
    }
}
